<template>
  <v-list
    dense
    two-line>
    <v-list-group append-icon>
      <v-list-tile slot="activator">
        <v-list-tile-content>
          <v-list-tile-title class="title">
            <v-layout column>
              <v-flex>
                <span class="title text-uppercase">{{ $t("Shipping") }}</span>
              </v-flex>
              <v-flex
                v-if="order.requested_delivery && order.unfulfilled.length > 0"
                class="my-0 py-0 caption"
              >
                <span>{{ $t("Requested delivery") }}</span
                >:
                <span class="font-weight-bold">
                  {{ order.requested_delivery | formatRequestedDelivery }}
                </span>
              </v-flex>
            </v-layout>
          </v-list-tile-title>
        </v-list-tile-content>

        <v-icon>keyboard_arrow_down</v-icon>

        <v-list-tile-action>
          <v-chip
            small
            color="primary"
            dark>
            {{ order.summary.total_shipping | money }}
          </v-chip>
        </v-list-tile-action>
      </v-list-tile>

      <v-layout>
        <v-flex
          class="mx-3 mt-3 headline"
          xs12>
          {{ $t("Shipping Details") }}
        </v-flex>
      </v-layout>

      <v-expansion-panels
        v-model="panel"
        :class="{ inactive: !order.shipping.discounts.length }"
      >
        <v-expansion-panel class="elevation-0">
          <v-expansion-panel-content
            :class="{ activator: !order.shipping.discounts.length }"
          >
            <template v-slot:header>
              <v-layout
                d-flex
                class="my-0 py-0 align-center">
                <v-flex
                  xs12
                  sm4>
                  {{ order.shipping.name }}
                </v-flex>
                <v-flex
                  xs12
                  sm4>
                  {{ $t("Type") }}:
                  <span class="text-capitalize">{{ order.shipping.type }}</span>
                </v-flex>
                <v-spacer />
                <v-flex
                  :class="$vuetify.rtl ? 'text-xs-left' : 'text-xs-right'"
                >
                  <v-chip
                    v-if="order.shipping.refunded"
                    color="secondary"
                    dark>
                    {{ $t("Refunded") }}
                  </v-chip>
                </v-flex>
                <v-flex
                  :class="$vuetify.rtl ? 'text-xs-left' : 'text-xs-right'"
                  class="mx-3"
                >
                  <span :class="{ 'd-none': !order.shipping.discounts.length }">
                    {{ $t("Included Discounts") }}
                  </span>
                </v-flex>
              </v-layout>
            </template>

            <v-layout
              v-if="order.shipping.discounts.length"
              class="mb-4 mx-4"
              column
            >
              <v-divider class="mt-3" />
              <order-discount-breakdown :discounts="order.shipping.discounts" />

              <v-divider />
              <order-discount-total
                :total-discount="order.summary.total_shipping_discount"
              />
            </v-layout>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <template v-if="order.shipments.length">
        <v-layout>
          <v-flex
            class="mx-3 headline"
            xs12>
            {{ $t("Shipments") }}
          </v-flex>
        </v-layout>

        <template>
          <div
            v-for="(shipment, index) in order.shipments"
            :key="shipment.id">
            <order-single-shipment-carrier-details :shipment="shipment" />

            <order-single-note
              v-if="shipment.note"
              :note="shipment.note"
              class="my-3"
            />

            <v-layout>
              <v-flex class="mx-3 subheading">
                {{ $t("Shipped items") }}:
              </v-flex>
            </v-layout>

            <order-single-shipment-items :items="shipment.items" />

            <v-divider
              v-if="
                order.shipments.length > 1 && index !== order.shipments.length
              "
              class="my-3"
            />
          </div>
        </template>
      </template>
    </v-list-group>
  </v-list>
</template>

<script>
import OrderSingleNote from './OrderSingleNote'
import OrderSingleShipmentItems from './OrderSingleShipmentItems'
import OrderSingleShipmentCarrierDetails from './OrderSingleShipmentCarrierDetails'
import OrderDiscountBreakdown from './OrderSingleDiscount/OrderDiscountBreakdown'
import OrderDiscountTotal from './OrderSingleDiscount/OrderDiscountTotal'

export default {
  name: 'OrderSingleSummaryShipping',

  components: {
    OrderDiscountTotal,
    OrderDiscountBreakdown,
    OrderSingleShipmentCarrierDetails,
    OrderSingleShipmentItems,
    OrderSingleNote
  },

  props: {
    order: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      panel: [true]
    }
  }
}
</script>

<style>
.activator:hover {
  cursor: default;
}

.activator .v-expansion-panel__header__icon {
  display: none;
}

.inactive {
  cursor: default;
  pointer-events: none;
}
</style>
